import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
function r(c, n) {
  return e(), l("svg", {
    height: "24",
    width: "24",
    viewBox: "0 0 512 512"
  }, [
    t("path", {
      style: { fill: "#FFDA44" },
      d: `M256,0c-23.106,0-45.49,3.08-66.783,8.819L166.957,256l22.261,247.181\r
	C210.51,508.92,232.894,512,256,512c141.384,0,256-114.616,256-256S397.384,0,256,0z`
    }),
    t("path", {
      style: { fill: "#6DA544" },
      d: `M166.957,256l22.261,247.181C210.51,508.92,232.894,512,256,512c141.384,0,256-114.616,256-256\r
	H166.957z`
    }),
    t("g", null, [
      t("path", {
        style: { fill: "#D80027" },
        d: "M0,256c0,97.035,53.99,181.455,133.565,224.873V31.127C53.99,74.545,0,158.965,0,256z"
      }),
      t("path", {
        style: { fill: "#D80027" },
        d: "M0,256c0,118.279,80.221,217.805,189.217,247.181V8.819C80.221,38.195,0,137.721,0,256z"
      })
    ]),
    t("polygon", { points: `96.736,189.217 113.311,240.233 166.957,240.233 123.559,271.765 140.133,322.783 96.736,291.252 53.337,322.783 \r
	69.915,271.765 26.517,240.233 80.16,240.233 ` })
  ]);
}
export {
  r as default
};
